import React from 'react';
import { DropDown } from 'cantarus-react-ui';
import { FieldDataStrings as Strings } from '../../../utils/config';

const FieldDataDropDown = ({ options, fieldName, fieldValue, handleFieldDataTextChange }) => {

    let selectedOption = null
    const dropdownPlaceholder = options.length === 0 ? Strings.noFieldOptionsPlaceholder : Strings.optionsPlaceholder;
    const dropdownOptions = options.map(option => {
        const dropdownOption = { value: option.Value, label: option.Name }

        if (dropdownOption.value === fieldValue) {
            selectedOption = dropdownOption
        }

        return dropdownOption
    });

    const handleChange = (option) => {
        handleFieldDataTextChange(fieldName, option.value);
    }

    return (
        <DropDown
            onChange={handleChange}
            placeholder={dropdownPlaceholder}
            disabled={options.length === 0}
            selected={selectedOption}
            options={dropdownOptions}
        />
    );
}

export default FieldDataDropDown;
